import React from "react";
import I9003 from "../../Assets/Group 9003.png";
import YouthOne from "../../Assets/YouthOne-1.png";
import YouthTwo from "../../Assets/YouthTwo-2.png";
import YouthThree from "../../Assets/YouthThree-3.png";
import YouthFour from "../../Assets/YouthFour-4.png";
import YouthFive from "../../Assets/YouthFive-5.png";
import YouthSix from "../../Assets/YouthSix-6.png";

function Everydaypractice() {
  return (
    <section className="padding-y bg-gradient-to-r from-gray-800 to-gray-900 text-white">
      <div className="container mx-auto flex flex-col items-center max-w-6xl px-4">
        <div className="w-full text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-bold">Some Quick Answers</h1>
        </div>
        <div className="bg-[rgba(43,101,150,0.27)] rounded-3xl p-6 w-full max-w-4xl">
          {/* First Row */}
          <div className="flex flex-col md:flex-row justify-between items-start gap-6 mb-8">
            <div className="flex flex-col items-center text-center md:w-1/3">
              <img className="mb-4" src={YouthOne} alt="Step 1" />
              <p className="text-lg font-semibold">What is Solace Uno?</p>
              <h3 className="text-sm md:text-base text-gray-300">
                Solace Uno is an AI companion designed to support young people
                aged 13 to 24 with their mental health challenges. It offers
                personalised guidance and support based on machine learning and
                expert insights.
              </h3>
            </div>
            <div className="flex flex-col items-center text-center md:w-1/3">
              <img className="mb-4" src={YouthTwo} alt="Step 2" />
              <p className="text-lg font-semibold">
                How can Solace Uno help me?
              </p>
              <h3 className="text-sm md:text-base text-gray-300">
                Solace Uno provides a friendly and empathetic virtual friend to
                talk to, offering advice, coping strategies, and resources
                tailored to your needs.
              </h3>
            </div>
            <div className="flex flex-col items-center text-center md:w-1/3">
              <img className="mb-4" src={YouthThree} alt="Step 3" />
              <p className="text-lg font-semibold">
                Who can join the pilot program?
              </p>
              <h3 className="text-sm md:text-base text-gray-300">
                We're looking for young people aged 13 to 24 who are interested
                in shaping the future of mental health support. Your feedback
                will be invaluable in refining Solace Uno and helping others.
              </h3>
            </div>
          </div>
          {/* Second Row */}
          <div className="flex justify-center items-center gap-6 mb-8">
            <img className="w-18 md:w-18" src={I9003} alt="Image1" />
            <img className="w-18 md:w-18" src={I9003} alt="Image2" />
          </div>
          {/* Third Row */}
          <div className="flex flex-col md:flex-row justify-between items-start gap-6">
            <div className="flex flex-col items-center text-center md:w-1/3">
              <img className="mb-4" src={YouthFour} alt="Step 4" />
              <p className="text-lg font-semibold">
                When will Solace Uno be available?
              </p>
              <h3 className="text-sm md:text-base text-gray-300">
                We plan to launch Solace Uno in Q1 2025, with pilot trials
                starting in late 2024. Sign up now to stay updated and be among
                the first to gain access.
              </h3>
            </div>
            <div className="flex flex-col items-center text-center md:w-1/3">
              <img className="mb-4" src={YouthFive} alt="Step 5" />
              <p className="text-lg font-semibold">
                Is my data safe with Solace Uno?
              </p>
              <h3 className="text-sm md:text-base text-gray-300">
                Absolutely. We prioritise your privacy and data protection. You
                are always in control of your information and you can delete it
                at any time if we ever part company.
              </h3>
            </div>
            <div className="flex flex-col items-center text-center md:w-1/3">
              <img className="mb-4" src={YouthSix} alt="Step 6" />
              <p className="text-lg font-semibold">How do I sign up?</p>
              <h3 className="text-sm md:text-base text-gray-300">
                Simply click join, fill out the form with your name and email
                address, and click "Join us Now." You'll receive updates and
                information about the pilot program and launch (we'll need to
                check you're a human first).
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Everydaypractice;
